/* @flow */
import Container from 'components/Container.jsx';
import FooterNavColumn from './FooterNavColumn.jsx';
import FooterNavItem from './FooterNavItem.jsx';
import Glyph from 'components/Glyph.jsx';
import LinkConstants from 'constants/LinkConstants';
import * as React from 'react';

import './styles/Footer.scss';

const FooterNavItemTosPp = () => (
  <FooterNavItem href={LinkConstants.TERMS_OF_SERVICE} color="violet">
    <Glyph name="lock-stroke" />
    <span>Terms & Privacy</span>
  </FooterNavItem>
);

const Footer = () => (
  <footer className="Footer">
    <Container full className="Footer-container">
      <nav className="Footer-nav">
        <FooterNavColumn className="Footer-tosPp">
          <FooterNavItemTosPp />
        </FooterNavColumn>
        <FooterNavColumn title="Features">
          <FooterNavItem href={LinkConstants.HOW_IT_WORKS_TEACHERS}>Learn More</FooterNavItem>
          <FooterNavItem href={LinkConstants.PLANS}>School & District Plans</FooterNavItem>
        </FooterNavColumn>
        <FooterNavColumn title="Community">
          <FooterNavItem href={LinkConstants.COMMUNITY}>Succeed Together</FooterNavItem>
          <FooterNavItem href={LinkConstants.BLOG}>Blog</FooterNavItem>
        </FooterNavColumn>
        <FooterNavColumn title="Culture">
          <FooterNavItem href={LinkConstants.ABOUT}>About Us</FooterNavItem>
          <FooterNavItem href={LinkConstants.PRESS}>Press</FooterNavItem>
          <FooterNavItem href={LinkConstants.CAREERS}>Careers</FooterNavItem>
        </FooterNavColumn>
        <FooterNavColumn title="Support">
          <FooterNavItem href={LinkConstants.HELP}>Help Center</FooterNavItem>
          <FooterNavItem href={LinkConstants.TRUST_SAFETY}>Trust & Safety</FooterNavItem>
          <FooterNavItem href={LinkConstants.RESOURCES}>Resources</FooterNavItem>
        </FooterNavColumn>
      </nav>
      <nav className="Footer-navSecondary">
        <FooterNavItemTosPp />
      </nav>
    </Container>
  </footer>
);

export default Footer;
